// Header.tsx
'use client';

import useDevice from '@/hooks/useDevice';
import PcHeader from './PcHeader';
import MobileHeader from './MobileHeader';

const Header = () => {
  const { isPc } = useDevice();
  
  return isPc ? <PcHeader /> : <MobileHeader />;
};

export default Header;